var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "dc_customize" } },
    [
      _c("dd-header", { ref: "menuRef" }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("h1", { staticClass: "hidden" }, [_vm._v("商品カスタマイズ")]),
              _vm._v(" "),
              _c("section", [
                _c("h2", { staticClass: "hidden" }, [_vm._v("商品情報")]),
                _vm._v(" "),
                _c("div", { attrs: { id: "product_header" } }, [
                  _c("div", { staticClass: "product_info" }, [
                    _c("div", { staticClass: "product_name" }, [
                      _vm._v(_vm._s(_vm.targetPlan.dcFdName))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "product_data" }, [
                  _c("div", { attrs: { id: "product-big-image" } }, [
                    _c("img", {
                      attrs: { src: _vm.getImage(_vm.targetPlan.dcFdImageB) }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.constructList && _vm.constructList.length > 0
                    ? _c("div", { attrs: { id: "construct" } }, [
                        _c(
                          "div",
                          { staticClass: "pc_construct" },
                          _vm._l(_vm.constructList, function(product, index) {
                            return _c(
                              "div",
                              {
                                key: "construct-" + index,
                                staticClass: "construct",
                                attrs: { value: product }
                              },
                              [
                                _c("img", {
                                  attrs: { src: product.img },
                                  on: {
                                    click: function($event) {
                                      _vm.previewConstruct(product)
                                    }
                                  }
                                })
                              ]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pc_hidden" },
                          [
                            _c("dd-consturct", {
                              ref: "ddCategoryListRef",
                              attrs: {
                                swipeList: _vm.constructList,
                                swiperOptions: _vm.constructOptions,
                                horizontalMode: false
                              },
                              on: { clickImage: _vm.previewConstruct }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "product_option" }, [
                  _c("div", { staticClass: "manual" }, [
                    _c(
                      "span",
                      {
                        class: { disabled: !_vm.targetPlan.cDcProductManual },
                        on: {
                          click: function($event) {
                            _vm.downloadManual(_vm.targetPlan.cDcProductManual)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.getYaImage("common/icon_pdf.svg") }
                        }),
                        _vm._v(" "),
                        _c("figcaption", [_vm._v("商品説明書ダウンロード")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: { disabled: !_vm.targetPlan.cDcConstructManual },
                        on: {
                          click: function($event) {
                            _vm.downloadManual(
                              _vm.targetPlan.cDcConstructManual
                            )
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.getYaImage("common/icon_pdf.svg") }
                        }),
                        _vm._v(" "),
                        _c("figcaption", [_vm._v("設置説明書ダウンロード")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: { disabled: !_vm.targetPlan.cDcUserManual },
                        on: {
                          click: function($event) {
                            _vm.downloadManual(_vm.targetPlan.cDcUserManual)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.getYaImage("common/icon_pdf.svg") }
                        }),
                        _vm._v(" "),
                        _c("figcaption", [_vm._v("取扱説明書ダウンロード")])
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "product_size_section" }, [
                _c("h3", [_vm._v(_vm._s(_vm.sizeInputTitle))]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "product_tab_content",
                      attrs: { id: "product_size" }
                    },
                    [
                      _vm.isTypeBeamCounter
                        ? _c(
                            "div",
                            [
                              _c("dd-param-shaped-l", {
                                ref: "paramCommonRef",
                                attrs: { targetPlan: _vm.targetPlan }
                              })
                            ],
                            1
                          )
                        : _vm.isParamShelfBoard
                          ? _c(
                              "div",
                              [
                                _c("dd-param-size2", {
                                  ref: "paramCommonRef",
                                  attrs: {
                                    targetPlan: _vm.targetPlan,
                                    isDisableForm: _vm.isSpaceJoincd,
                                    isExecOrder: _vm.isExecOrder,
                                    isShelf: _vm.isShelf,
                                    isShelfType: _vm.isShelfType
                                  }
                                })
                              ],
                              1
                            )
                          : _vm.categoryType == 4
                            ? _c(
                                "div",
                                [
                                  _c("dd-param-size", {
                                    ref: "paramCommonRef",
                                    attrs: {
                                      targetPlan: _vm.targetPlan,
                                      isDisableForm: _vm.isSpaceJoincd,
                                      isExecOrder: _vm.isExecOrder
                                    },
                                    on: { changeWallFlag: _vm.changeWallFlag }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("dd-param-size-filler", {
                                    ref: "paramCommonRef",
                                    attrs: {
                                      targetPlan: _vm.targetPlan,
                                      isDisableForm: _vm.isSpaceJoincd,
                                      isExecOrder: _vm.isExecOrder,
                                      isStruct: _vm.isResearch,
                                      isExistEndPanel: _vm.isExistEndPanel,
                                      isMiura: _vm.isMiuraCompany
                                    }
                                  })
                                ],
                                1
                              )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "color_section" }, [
                _c("h3", [_vm._v("■商品カラーの選択")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "※ カラー画像について、ご利用のパソコン・スマートフォンのモニターによってカラーの見え方が違ったり、実際の商品と色味や色柄が異なる場合がございます。予めご了承頂きますようお願いいたします。"
                  )
                ]),
                _vm._v(" "),
                _vm.colorStyleList.length > 0
                  ? _c(
                      "div",
                      { attrs: { id: "color-door-style" } },
                      [
                        _c("dd-color-style", {
                          ref: "styleColorDoor",
                          attrs: {
                            title: "扉/エンドパネル/カウンター",
                            styleList: _vm.colorStyleList,
                            selectColorStyle: _vm.selectColorStyle
                          },
                          on: { changeColorStyle: _vm.changeColorStyle }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "space" }),
                _vm._v(" "),
                _vm.doorColorList.length > 0
                  ? _c(
                      "div",
                      { attrs: { id: "color-door" } },
                      [
                        _c("dd-color-pallet", {
                          ref: "colorPalletDoor",
                          attrs: {
                            documentId: "doorId",
                            title: _vm.doorColorTitle,
                            colorList: _vm.doorColorList,
                            color: _vm.colorDoor
                          },
                          on: { selectColor: _vm.selectDoorColor }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "space" }),
                _vm._v(" "),
                _vm.counterColorList.length > 0
                  ? _c(
                      "div",
                      { attrs: { id: "color-counter" } },
                      [
                        _c("dd-color-pallet", {
                          ref: "colorPalletCounter",
                          attrs: {
                            documentId: "counterId",
                            title: "カウンターカラーを選択ください",
                            colorList: _vm.counterColorList,
                            color: _vm.colorCounter
                          },
                          on: { selectColor: _vm.selectCounterColor }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.cabineColorList.length > 0
                  ? _c(
                      "div",
                      { attrs: { id: "color-cabine" } },
                      [
                        _c("dd-color-pallet", {
                          ref: "colorPalletCabine",
                          attrs: {
                            documentId: "cabineId",
                            title: "キャビネット/棚/脚カラーを選択ください",
                            colorList: _vm.cabineColorList,
                            color: _vm.colorCabine
                          },
                          on: { selectColor: _vm.selectCabineColor }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "separate_line" })
              ]),
              _vm._v(" "),
              _c("section", [
                _vm.targetPlan.dcCategoryType == 5
                  ? _c("div", { staticClass: "product_tab_content" }, [
                      _c("h3", [_vm._v("■ご注文数を選択ください")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content_line" }, [
                        _c("label", [_vm._v("ご注文数")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dcBoardCount,
                              expression: "dcBoardCount"
                            }
                          ],
                          attrs: { type: "text", maxlength: "2" },
                          domProps: { value: _vm.dcBoardCount },
                          on: {
                            keypress: _vm.validateNumber,
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.dcBoardCount = $event.target.value
                              },
                              function($event) {
                                _vm.dcBoardCount = _vm.inputRestNumber($event)
                              }
                            ],
                            blur: _vm.onBlurOpBoardCount
                          }
                        }),
                        _vm._v("枚\n            ")
                      ])
                    ])
                  : _vm.targetPlan.dcCategoryType !== 4 &&
                    !(
                      _vm.targetPlan.opShelfType === 1 &&
                      _vm.targetPlan.opFillerType === 1
                    )
                    ? _c(
                        "div",
                        {
                          staticClass: "product_tab_content",
                          attrs: { id: "customize_option" }
                        },
                        [
                          _c("h3", [_vm._v("■追加部材をご選択ください。")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input_btn_area" }, [
                            _c("div", [
                              _vm.targetPlan.opShelfType !== 1
                                ? _c("div", { staticClass: "content_line" }, [
                                    _c("div", [
                                      _c("div", [_vm._v("可動棚")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "label",
                                          { staticClass: "option_check" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.isAddShelf,
                                                  expression: "isAddShelf"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "opt_shelf",
                                                disabled:
                                                  _vm.targetPlan.opShelfType ==
                                                  2
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.isAddShelf
                                                )
                                                  ? _vm._i(
                                                      _vm.isAddShelf,
                                                      null
                                                    ) > -1
                                                  : _vm.isAddShelf
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.isAddShelf,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.isAddShelf = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.isAddShelf = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.isAddShelf = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "opt_check"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "opt_label" },
                                              [_vm._v("追加")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.dcShelfCount,
                                              expression: "dcShelfCount"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            maxlength: "2",
                                            disabled: !_vm.isAddShelf
                                          },
                                          domProps: { value: _vm.dcShelfCount },
                                          on: {
                                            keypress: _vm.validateNumber,
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.dcShelfCount =
                                                  $event.target.value
                                              },
                                              function($event) {
                                                _vm.dcShelfCount = _vm.inputRestNumber(
                                                  $event
                                                )
                                              }
                                            ],
                                            blur: _vm.onBlurOpShelfCount
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "※列ごとに指定枚数追加されます。"
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.targetPlan.opFillerType !== 1
                                ? _c("div", { staticClass: "content_line" }, [
                                    _c("div", [
                                      _c("div", [_vm._v("フィラー")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "label",
                                          { staticClass: "option_check" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.isAddFiller,
                                                  expression: "isAddFiller"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "opt_filler",
                                                disabled:
                                                  _vm.targetPlan.opFillerType ==
                                                  2
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.isAddFiller
                                                )
                                                  ? _vm._i(
                                                      _vm.isAddFiller,
                                                      null
                                                    ) > -1
                                                  : _vm.isAddFiller
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.isAddFiller,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.isAddFiller = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.isAddFiller = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.isAddFiller = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "opt_check"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "opt_label" },
                                              [_vm._v("追加")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.dcFillerCount,
                                              expression: "dcFillerCount"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            maxlength: "2",
                                            disabled: !_vm.isAddFiller
                                          },
                                          domProps: {
                                            value: _vm.dcFillerCount
                                          },
                                          on: {
                                            keypress: _vm.validateNumber,
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.dcFillerCount =
                                                  $event.target.value
                                              },
                                              function($event) {
                                                _vm.dcFillerCount = _vm.inputRestNumber(
                                                  $event
                                                )
                                              }
                                            ],
                                            blur: _vm.onBlurOpFillerCount
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "※追加フィラーの寸法は、" +
                                            _vm._s(_vm.fillerSize) +
                                            "mm×200mm×1800mmです。"
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                _vm._v(" "),
                _vm.targetPlan.dcCategoryType == 5 ||
                (_vm.targetPlan.dcCategoryType !== 4 &&
                  !(
                    _vm.targetPlan.opShelfType === 1 &&
                    _vm.targetPlan.opFillerType === 1
                  ))
                  ? _c("div", { staticClass: "separate_line" })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("section", { attrs: { id: "input_delivery" } }, [
                _c("h3", [_vm._v("■ お届け先郵便番号の入力")]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { attrs: { for: "delivery_input_address" } }, [
                    _vm._v("郵便番号（半角、ハイフンなし）")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.deliveryForm.postcd,
                          expression: "deliveryForm.postcd"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>7)value=value.slice(0,7)"
                      },
                      domProps: { value: _vm.deliveryForm.postcd },
                      on: {
                        keypress: _vm.validateNumber,
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.deliveryForm,
                              "postcd",
                              $event.target.value
                            )
                          },
                          function($event) {
                            _vm.deliveryForm.postcd = _vm.convertHalfNumber(
                              $event
                            )
                          }
                        ]
                      }
                    }),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _vm.errors.deliveryPostcd
                    ? _c("div", { staticClass: "error_text middle_text" }, [
                        _vm._v(_vm._s(_vm.errors.deliveryPostcd))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "separate_line" })
              ]),
              _vm._v(" "),
              _vm.isViewConstruct
                ? _c("section", { attrs: { id: "input_construct" } }, [
                    _c("h3", [_vm._v("■ 組立設置サービスの選択")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input_btn_area" }, [
                      _c("div", [
                        _c("div", { attrs: { id: "construction" } }, [
                          _c("div", { staticClass: "radio_check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.workFlag,
                                  expression: "workFlag",
                                  modifiers: { number: true }
                                }
                              ],
                              class: {
                                radio_no: _vm.isSelectConstruct,
                                radio_no_disable: !_vm.isSelectConstruct
                              },
                              attrs: {
                                type: "radio",
                                name: "construction_radio",
                                id: "construction_no",
                                checked: "",
                                value: "0"
                              },
                              domProps: {
                                checked: _vm._q(_vm.workFlag, _vm._n("0"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.workFlag = _vm._n("0")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "radio-label",
                                attrs: { for: "construction_no" }
                              },
                              [_vm._v("なし")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio_check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.workFlag,
                                  expression: "workFlag",
                                  modifiers: { number: true }
                                }
                              ],
                              class: {
                                radio_need: _vm.isSelectConstruct,
                                radio_need_disable: !_vm.isSelectConstruct
                              },
                              attrs: {
                                type: "radio",
                                name: "construction_radio",
                                id: "construction_need",
                                value: "1"
                              },
                              domProps: {
                                checked: _vm._q(_vm.workFlag, _vm._n("1"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.workFlag = _vm._n("1")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "radio-label",
                                attrs: { for: "construction_need" }
                              },
                              [_vm._v("あり")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "small_text" }, [
                          _vm._v(
                            "※組立設置をご希望の場合、担当者よりご連絡いたします。"
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isOtherContruct
                          ? _c("div", { staticClass: "red" }, [
                              _vm._v(
                                "※水道工事、電気工事は承れませんので、ご自身での手配をお願いいたします。"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isConstruct
                          ? _c("div", { staticClass: "customize_order" }, [
                              _c("div", { staticClass: "radio_check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isStructSameAddress,
                                      expression: "isStructSameAddress"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: "const_someaddress",
                                    name: "struct_address"
                                  },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.isStructSameAddress,
                                      true
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        _vm.isStructSameAddress = true
                                      },
                                      function($event) {
                                        _vm.changeNewStruct()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-label",
                                    attrs: { for: "const_someaddress" }
                                  },
                                  [_vm._v("納品先と同じ住所")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "radio_check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isStructSameAddress,
                                      expression: "isStructSameAddress"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: "const_differ",
                                    name: "struct_address"
                                  },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.isStructSameAddress,
                                      false
                                    )
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        _vm.isStructSameAddress = false
                                      },
                                      function($event) {
                                        _vm.changeNewStruct()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "radio-label",
                                    attrs: { for: "const_differ" }
                                  },
                                  [_vm._v("納品先住所と異なる住所の郵便番号")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "sub_label",
                                    attrs: { for: "const_differ" }
                                  },
                                  [_vm._v("（半角、ハイフンなし）")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      disable_form: _vm.isStructSameAddress,
                                      address_form: true
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.constructForm.postcd,
                                          expression: "constructForm.postcd"
                                        }
                                      ],
                                      attrs: {
                                        type: "text",
                                        oninput:
                                          "if(value.length>7)value=value.slice(0,7)"
                                      },
                                      domProps: {
                                        value: _vm.constructForm.postcd
                                      },
                                      on: {
                                        keypress: _vm.validateNumber,
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.constructForm,
                                              "postcd",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            _vm.constructForm.postcd = _vm.convertHalfNumber(
                                              $event
                                            )
                                          }
                                        ]
                                      }
                                    }),
                                    _c("br")
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.constructPostcd
                                  ? _c(
                                      "div",
                                      { staticClass: "error_text middle_text" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.constructPostcd)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm._m(2)
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "separate_line" })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("section", { staticClass: "product_order_cost" }, [
                _c(
                  "div",
                  {
                    staticClass: "n_separator",
                    attrs: { id: "product_order" }
                  },
                  [
                    _c("div", { staticClass: "order_cost" }, [
                      _c("div", [_vm._v(_vm._s(_vm.itemName))]),
                      _vm._v(" "),
                      _c("div"),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPrice(
                              _vm.priceData.itemPrice *
                                _vm.priceData.productCount
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_cost" }, [
                      _c("div", [_vm._v("配送料")]),
                      _vm._v(" "),
                      _c("div"),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPrice(
                              _vm.priceData.delivaryPrice *
                                _vm.priceData.productCount
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_cost" }, [
                      _c("div", [_vm._v("消費税")]),
                      _vm._v(" "),
                      _c("div"),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.formatPrice(_vm.priceData.subTotalTax))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "separate_line2" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_cost" }, [
                      _c("div", [_vm._v("商品・配送費小計")]),
                      _vm._v(" "),
                      _c("div"),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPrice(
                              _vm.priceData.subTotalPrice +
                                _vm.priceData.subTotalTax
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "separate_line2" }),
                    _vm._v(" "),
                    _vm.workFlag
                      ? _c("div", [
                          _c("div", { staticClass: "order_cost" }, [
                            _c("div", [_vm._v("組立技術料")]),
                            _vm._v(" "),
                            _c("div"),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.priceData.constructPrice *
                                      _vm.priceData.productCount
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.priceData.carryInPrice
                            ? _c("div", { staticClass: "order_cost" }, [
                                _c("div", [_vm._v("受け取り搬入サービス費")]),
                                _vm._v(" "),
                                _c("div"),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatPrice(
                                        _vm.priceData.carryInPrice *
                                          _vm.priceData.productCount
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "order_cost" }, [
                            _c("div", [_vm._v("諸経費")]),
                            _vm._v(" "),
                            _c("div"),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.priceData.executionVarExpensesPrice
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "order_cost" }, [
                            _c("div", [_vm._v("消費税")]),
                            _vm._v(" "),
                            _c("div"),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.priceData.constructTotalTax
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "separate_line2" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "order_cost" }, [
                            _c("div", [
                              _vm._v("組立設置他サービス小計（税込）")
                            ]),
                            _vm._v(" "),
                            _c("div"),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.priceData.constructTotalPrice +
                                      _vm.priceData.constructTotalTax
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.workFlag
                      ? _c("div", { staticClass: "separate_line" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.createPlanFlag === true,
                            expression: "createPlanFlag===true"
                          }
                        ],
                        staticClass: "lds-sub-spinner"
                      },
                      [_vm._m(3)]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product_order_line total_price" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "space" }),
                        _vm._v(" "),
                        _vm.resrchFlag
                          ? _c("div", { staticClass: "price big_text2 bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPrice(
                                    _vm.priceData.resrchTotalPrice
                                  )
                                )
                              )
                            ])
                          : !_vm.isPlanning
                            ? _c(
                                "div",
                                { staticClass: "price big_text2 bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatPrice(_vm.priceData.totalTax)
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "price big_text2 bold" },
                                [_vm._v(_vm._s(_vm.priceCalcText))]
                              )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_action_area" }, [
                      _c("div"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action_area" },
                        [
                          false
                            ? _c(
                                "div",
                                {
                                  class: {
                                    main_btn: true,
                                    act_sub_btn: true,
                                    disabled: !_vm.isExecOrder
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.onReEstimate()
                                    },
                                    mouseover: function($event) {
                                      _vm.isOnReload(true)
                                    },
                                    mouseleave: function($event) {
                                      _vm.isOnReload(false)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "icon",
                                    attrs: { src: _vm.imgReload }
                                  }),
                                  _vm._v(" "),
                                  _c("a", [_vm._v("再計算")])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resrchFlag
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "main_btn sel_main_btn",
                                    on: {
                                      click: function($event) {
                                        _vm.resrch()
                                      }
                                    }
                                  },
                                  [_c("a", [_vm._v("事前現場調査見積り")])]
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "order_counter" },
                                  [
                                    _vm.targetPlan.dcCategoryType !== 5 &&
                                    !_vm.resrchFlag
                                      ? _c("dd-counter", {
                                          ref: "ddCounterRef",
                                          attrs: {
                                            initCount:
                                              _vm.targetPlan.dcProductCount
                                          }
                                        })
                                      : _c("div")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      main_btn: true,
                                      sel_main_btn: true,
                                      disabled: !_vm.isExecOrder
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onShowEstimateModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("a", [
                                      _vm._v(_vm._s(_vm.estimteBtnTitle))
                                    ])
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ])
                  ]
                )
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", { staticClass: "opt_text" }, [_vm._v("枚/列を入力")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", { staticClass: "opt_text" }, [_vm._v("本数を入力")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customize_sub" }, [
      _c("div", [_vm._v("※")]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [_vm._v("組立設置オプションには以下の費用が発生します。")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("組立技術料：組立作業費および副資材、簡易養生材など。")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("諸経費：交通費、燃料代など。")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-spinner lds-spinner-pos" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", [_vm._v("合計金額（税込）")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59bfd175", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59bfd175","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcCustomize.vue
// module id = null
// module chunks = 